/****************************************************
 * Module Name:  kapanIssueReceiveMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import * as React from "react";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import IssueMaster from './issueMaster'
import Constants from "../../utility/constants";
import { BsClipboardCheck, BsClipboardPlus } from "react-icons/bs";
import ReceiveMaster from "./receiveMaster";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 1 }}>
                    <Typography component={"span"}>{children}</Typography>
                </Box>
            )}
        </Box>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
        value: index,
    };
}

export default function KapanIssueReceiveMaster() {
    const theme = useTheme();
    const [value, setValue] = React.useState(
        Constants.USER_PERMISSION.find(
            (iPermission) =>
                iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEIPT
        ) !== undefined
            ? 0
            : Constants.USER_PERMISSION.find(
                (iPermission) =>
                    iPermission.permissionid ===
                    Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEPT_RECEIPT
            ) !== undefined
                ? 1
                : 0
    );

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return (
        // <Container maxWidth="xxl">
        <Box
            sx={{ bgcolor: "background.paper", width: "100%", padding: "10px" }}
        >
            <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                    sx={{
                        "& .css-1vw5i9y-MuiButtonBase-root-MuiTab-root": {
                            color: "#212121",
                            fontWeight: Constants.defaultFontWeightBold,
                            textAlign: 'center'
                        },
                        "& .MuiTab-root": {
                            paddingBottom: 4
                        },
                        "& .Mui-selected": {
                            bgcolor: "#0277bd !important",
                            color: "#fafafa !important",
                            fontWeight: "bold !important",
                            paddingBottom: 4
                        }
                    }}
                    TabIndicatorProps={{ style: { background: "#0277bd" } }}
                >
                    {Constants.USER_PERMISSION.find(
                        (iPermission) =>
                            iPermission.permissionid ===
                            Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEIPT
                    ) !== undefined ? (
                        <Tab
                            icon={<BsClipboardPlus />}
                            iconPosition="start"
                            label="ISSUE"
                            {...a11yProps(0)}
                        />
                    ) : null}
                    {Constants.USER_PERMISSION.find(
                        (iPermission) =>
                            iPermission.permissionid ===
                            Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEPT_RECEIPT
                    ) !== undefined ? (
                        <Tab
                            icon={<BsClipboardCheck />}
                            iconPosition="start"
                            label="RECEIVE"
                            {...a11yProps(1)}
                        />
                    ) : null}
                </Tabs>
            </AppBar>
            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                {Constants.USER_PERMISSION.find(
                    (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEIPT
                ) !== undefined ? (
                    <TabPanel value={value} index={0}>
                        <IssueMaster />
                    </TabPanel>
                ) : null}
                {Constants.USER_PERMISSION.find(
                    (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEPT_RECEIPT
                ) !== undefined ? (
                    <TabPanel value={value} index={1}>
                        <ReceiveMaster />
                    </TabPanel>
                ) : null}
            </SwipeableViews>
        </Box>
        // </Container>
    );
}
